export const MENU_LABEL = {
	PROFILE: {
		'profile-main': 'Perfil',
		'profile-user': 'Mi Cuenta',
		'profile-logout': 'Cerrar Sesión',
	},
};
